import { Component, OnDestroy, OnInit } from '@angular/core';
import { BaseWithBundleComponent } from '@app/shared/components/base/base-with-bundle.component';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { WorkflowTargets } from '@app/shared/models/workflow';

@Component({
    templateUrl: './workflow-management.component.html',
    styleUrls: ['./workflow-management.component.scss']
})
export class WorkflowManagementComponent extends BaseWithBundleComponent
                                         implements OnInit, OnDestroy {

    get WorkflowTarget() {
        return WorkflowTargets;
    }

    public constructor(protected componentServiceBundle: ComponentServiceBundle) {
        super(componentServiceBundle);
        this._idPrefix = 'settings-workflow-management.';
    }

    public ngOnInit() {
        super.ngOnInit();
    }

    public ngOnDestroy() {
        super.ngOnDestroy();
    }

}
